module.exports = function (Swiper) {

    if (document.querySelector('.fxc-heading-content-list')) {
        fSwiper()
    }

    function fSwiper() {
        // let swiper = new Swiper('.fxc-heading-content-list .swiper-container', {
        //     slidesPerView: 1,
        //     spaceBetween: 0,
        //     pagination: {
        //         el: '.swiper-pagination',
        //         type: 'progressbar',
        //     },
        //     breakpoints: {
        //         576: {
        //             slidesPerView: 1,
        //             spaceBetween: 0,
        //         },
        //         768: {
        //             slidesPerView: 2,
        //             spaceBetween: 0,
        //         }
        //     }
        // });
        if (window.innerWidth < 1440) {
            // swiper = new Swiper('.fxc-heading-content-list .swiper-container', {
            //     slidesPerView: 1,
            //     spaceBetween: 0,
            //     pagination: {
            //         el: '.swiper-pagination',
            //         type: 'progressbar',
            //     },
            //     breakpoints: {
            //         576: {
            //             slidesPerView: 1,
            //             spaceBetween: 0,
            //         },
            //         768: {
            //             slidesPerView: 2,
            //             spaceBetween: 20,
            //         }
            //     }
            // });
        } else {
            // console.log('destroy swiper');
            // swiper.destroy(true, true)
        }
    }

};